import {
  CreatePaylinkSubscriptionHookDto,
  PaylinkSubscriptionHookEntity,
} from '@heliofi/common';
import { ApiAdapter } from '../../ApiAdapter';

export class SubscriptionWebhookSDK {
  private readonly apiAdapter: ApiAdapter;

  constructor(apiAdapter: ApiAdapter) {
    this.apiAdapter = apiAdapter;
  }

  async createSubscriptionWebhook(
    payload: CreatePaylinkSubscriptionHookDto,
  ): Promise<PaylinkSubscriptionHookEntity> {
    return this.apiAdapter.post(
      '/webhook/paylink/subscription',
      payload,
      'Failed to create subscription webhook',
    );
  }

  async getAllSubscriptionWebhooks(
    paylinkId: string,
  ): Promise<PaylinkSubscriptionHookEntity[]> {
    return this.apiAdapter.get(
      '/webhook/paylink/subscription',
      'Failed to get all subscription webhooks',
      { paylinkId },
    );
  }

  async getSubscriptionWebhook(
    webhookId: string,
  ): Promise<PaylinkSubscriptionHookEntity> {
    return this.apiAdapter.get(
      `/webhook/paylink/subscription/${webhookId}`,
      'Failed to get subscription webhook',
    );
  }

  async deleteSubscriptionWebhook(webhookId: string): Promise<void> {
    return this.apiAdapter.delete(
      `/webhook/paylink/subscription/${webhookId}`,
      'Failed to delete subscription webhook',
    );
  }
}
